export default __webpack_public_path__ + "static/media/upload.6228cbbe.svg";